function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgBook = function SvgBook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    width: "1em",
    height: "1em"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M7 7v32c0 4.4 3.6 8 8 8h18c4.4 0 8-3.6 8-8V11H10.8C8.7 11 7 9.3 7 7.2 7 5.6 8.1 4.3 9.6 4L37 1v10",
    style: {
      fill: "none",
      stroke: "#000",
      strokeWidth: 2,
      strokeMiterlimit: 10
    }
  }));
};
export default SvgBook;